import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const entNivelesAcademicosApi = `${baseUrl}/entidad-niveles-academicos`;

export const allEntNivelesAcademicosService = async (params) => {
  const res = await axios.get(entNivelesAcademicosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntNivelesAcademicosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entNivelesAcademicosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entNivelesAcademicosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntNivelesAcademicosService = async (id) => {
  const res = await axios.get(`${entNivelesAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntNivelesAcademicosService = async (id) => {
  const res = await axios.delete(`${entNivelesAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
